/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==========================================================================
   GLOBAL MULTI-MARQUEE CAROUSEL (STRICT 1-BY-1 SNAP ENGINE)
   ========================================================================== */

if (!window.marqueeScriptInitialized) {
  window.marqueeScriptInitialized = true;

  document.addEventListener('DOMContentLoaded', () => {
    const instances = document.querySelectorAll('.js-marquee-instance');

    instances.forEach((instance) => {
      const windowEl = instance.querySelector('.js-marquee-window');
      const trackGroups = windowEl ? windowEl.querySelectorAll('.custom-track-group') : [];
      
      if (!windowEl || trackGroups.length === 0) return;

      const prevBtn = instance.querySelector('.js-marquee-prev');
      const nextBtn = instance.querySelector('.js-marquee-next');

      // Helper function to read current card metrics (Width 180px/260px + 20px gap)
      function getCardUnitWidth() {
        const firstCard = instance.querySelector('.custom-product-card');
        return firstCard ? firstCard.offsetWidth + 20 : 200;
      }

      // Desktop Click Listeners
      const scrollAmount = 280;
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          windowEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          windowEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }

      // --- Strict 1-by-1 Mobile Swipe State Machine ---
      let startX = 0;
      let startY = 0;
      let initialScrollLeft = 0;
      let isTouchActive = false;
      let hasScrolledVertically = false;

      windowEl.addEventListener('touchstart', (e) => {
        isTouchActive = true;
        hasScrolledVertically = false;
        
        // Kill smooth scrolling instantly to freeze track position on finger down
        windowEl.style.scrollBehavior = 'auto';
        
        // Pause all automatic marquee timelines
        trackGroups.forEach(group => {
          group.style.animationPlayState = 'paused';
        });

        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        initialScrollLeft = windowEl.scrollLeft;
      }, { passive: true });

      windowEl.addEventListener('touchmove', (e) => {
        if (!isTouchActive || hasScrolledVertically) return;

        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        
        const deltaX = startX - currentX;
        const deltaY = startY - currentY;

        // If user is mostly scrolling up/down the web page, don't hijack the touch
        if (!hasScrolledVertically && Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) {
          hasScrolledVertically = true;
          return;
        }

        // 1:1 pure tracking of finger alignment (no compounding speed calculations)
        windowEl.scrollLeft = initialScrollLeft + deltaX;
      }, { passive: true });

      windowEl.addEventListener('touchend', (e) => {
        if (!isTouchActive) return;
        isTouchActive = false;

        if (hasScrolledVertically) {
          resumeMarquee();
          return;
        }

        // Restore smooth layout behavior for the snap transition animation
        windowEl.style.scrollBehavior = 'smooth';

        const finalX = e.changedTouches[0].clientX;
        const totalDistanceDragged = startX - finalX;
        const cardUnitWidth = getCardUnitWidth();

        // Calculate the current exact column index position
        const currentRelativeIndex = initialScrollLeft / cardUnitWidth;
        let targetIndex = Math.round(currentRelativeIndex);

        // FORCED 1-BY-1 CONSTRAINT: Check drag threshold direction limits
        if (totalDistanceDragged > 40) {
          // Intentional left swipe -> Increment index strictly by exactly ONE card step
          targetIndex = Math.floor(currentRelativeIndex) + 1;
        } else if (totalDistanceDragged < -40) {
          // Intentional right swipe -> Decrement index strictly by exactly ONE card step
          targetIndex = Math.ceil(currentRelativeIndex) - 1;
        }

        // Translate the target index safely back down to pixel coordinates
        const targetScrollLeft = targetIndex * cardUnitWidth;
        windowEl.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });

        // Boundary processing execution delay loop
        setTimeout(() => {
          const singleGroup = instance.querySelector('.custom-track-group');
          if (singleGroup) {
            const groupWidth = singleGroup.offsetWidth;
            if (windowEl.scrollLeft >= groupWidth) {
              windowEl.scrollLeft -= groupWidth;
            } else if (windowEl.scrollLeft <= 0) {
              windowEl.scrollLeft += groupWidth;
            }
          }
          resumeMarquee();
        }, 350); 
      });

      function resumeMarquee() {
        if (!windowEl.matches(':hover') && !isTouchActive) {
          trackGroups.forEach(group => {
            group.style.animationPlayState = 'running';
          });
        }
      }
    });
  });
}

